/*
 * Main Menu Molecule Component
 *
 */
// TODO: Refactor to create separate `<SubMenuItem />` and `<MenuItem /> components
// TODO: If menu link is active, set styles + is subMenu button is active set subMenu button to active also.

import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import { useWindowDimensions } from "../../../hooks/useWindowDimensions"
import { useClickAway } from "../../../hooks/useClickAway"
import Button from "../../atoms/button/button"
import Link from "../../atoms/link/link"

const MainMenu = () => {
  const windowDimensions = useWindowDimensions()
  let windowWidth = windowDimensions.width
  const [isMobile, setIsMobile] = useState(true)
  const [isHovered, setIsHovered] = useState(false)
  const [submenuOpen, setSubmenuOpen] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const isMobileBreakpoint = 1200 // $breakpoint-l: 1200px;

  const openMenu = () => {
    setMenuOpen(true)
  }

  const closeMenu = () => {
    setMenuOpen(false)
  }

  const ref = useClickAway(() => {
    setMenuOpen(false)
  })

  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen)
  }

  const closeAllSubmenus = () => {
    setSubmenuOpen(false)
  }

  // Update isMobile when windowWidth changes
  useEffect(() => {
    if (windowWidth < isMobileBreakpoint) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [windowWidth])

  useEffect(() => {
    if (isMobile) {
      setMenuOpen(false)
    } else {
      setMenuOpen(true)
    }
  }, [isMobile])

  // Add no-scroll class to body tag if menu is open in mobile state to prevent scroll behavior
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("no-scroll")
    } else {
      document.body.classList.remove("no-scroll")
    }

    if (!isMobile) {
      document.body.classList.remove("no-scroll")
    }
  }, [menuOpen, isMobile])

  // Prevent menu closing in mobile state when opening submenu using keyboard / touch
  // TODO: Actually menu closes then re-opens, this needs to be fixed
  useEffect(() => {
    if (isMobile) {
      if (submenuOpen) {
        setMenuOpen(true)
      }
    }
  }, [submenuOpen, isMobile])

  const subMenuHoverTrue = () => {
    setIsHovered(true)
    toggleSubmenu()
  }

  const subMenuHoverFalse = () => {
    setIsHovered(false)
    closeAllSubmenus()
  }

  const subMenuClicked = () => {
    if (isHovered) {
      navigate("/resources-hub/")
      closeAllSubmenus()
      closeMenu()
    } else {
      toggleSubmenu()
    }
  }

  return (
    <>
      <div className="main-menu--is-mobile">
        <Button
          onClick={openMenu}
          srOnly="Open"
          text="Menu"
          hasPopup="true"
          ariaControls="menu"
          ariaExpanded={menuOpen ? true : false}
          icon="menu"
          iconModifier="--small"
          modifier="--open-menu"
        />
        <div
          className={`main-menu main-menu--mobile ${menuOpen ? "is-open" : ""}`}
          id="menu"
          aria-modal={true}
        >
          <Button
            onClick={closeMenu}
            srOnly="Menu"
            text="Close"
            icon="close"
            ariaControls="menu"
            iconModifier="--small"
            modifier="--close-button"
          />

          <nav aria-label="Main Navigation Menu">
            <ul className="main-menu__menu" ref={ref}>
              {/* Menu Item 1 */}
              <li className="main-menu__menu-list-item">
                <Link text="About Us" to="/about-us/" modifier="--menu-item" />
              </li>

              {/* Menu Item 2 */}
              <li className="main-menu__menu-list-item">
                <Link
                  text="Our Members"
                  to="/our-members/"
                  modifier="--menu-item"
                />
              </li>

              {/* Menu Item 3 */}
              <li className="main-menu__menu-list-item">
                <Link
                  text="Projects Showcase"
                  to="/projects-showcase/"
                  modifier="--menu-item"
                />
              </li>

              {/* Menu Item 4 with Submenu */}
              <li
                className={`main-menu__menu-list-item main-menu__menu-list-item--has-submenu ${
                  submenuOpen ? "main-menu__submenu--open" : ""
                }`}
              >
                <Button
                  modifier="--submenu-button"
                  text="Resources Hub"
                  onClick={subMenuClicked}
                  onMouseEnter={subMenuHoverTrue}
                  onMouseOut={subMenuHoverFalse}
                  onMouseLeave={subMenuHoverFalse}
                  hasPopup="true"
                  ariaExpanded={submenuOpen}
                  onBlur={() => void 0}
                  icon="chevron"
                  ariaControls="submenu-dropdown-1"
                />

                <div className="main-menu__submenu">
                  <ul
                    className="main-menu__submenu-list"
                    id="submenu-dropdown-1"
                    aria-label="Submenu Dropdown"
                  >
                    {/* Submenu Item 1 */}
                    <li className="main-menu__menu-list-item">
                      <Link
                        text="All Resources"
                        to="/resources-hub/"
                        modifier="--menu-item"
                      />
                    </li>

                    {/* Submenu Item 2 */}
                    <li className="main-menu__menu-list-item">
                      <Link
                        text="News"
                        to="/resources/news-posts/"
                        modifier="--menu-item"
                      />
                    </li>

                    {/* Submenu Item 3 */}
                    <li className="main-menu__menu-list-item">
                      <Link
                        text="Events"
                        to="/resources/event-posts/"
                        modifier="--menu-item"
                      />
                    </li>

                    {/* Submenu Item 4 */}
                    <li className="main-menu__menu-list-item">
                      <Link
                        text="Publications"
                        to="/resources/publications/"
                        modifier="--menu-item"
                      />
                    </li>

                    {/* Submenu Item 5 */}
                    <li className="main-menu__menu-list-item">
                      <Link
                        text="Newsletter"
                        to="/resources/newsletter/"
                        modifier="--menu-item"
                      />
                    </li>

                    {/* Submenu Item 6 */}
                    <li className="main-menu__menu-list-item">
                      <Link
                        text="Press Kit"
                        to="/resources/press-kit/"
                        modifier="--menu-item"
                      />
                    </li>
                  </ul>
                </div>
              </li>

              {/* Menu Item 5 */}
              <li className="main-menu__menu-list-item">
                <Link
                  text="Contact Us"
                  to="/contact-us/"
                  modifier="--menu-item"
                />
              </li>

              {/* Menu Item 6 */}
              <li className="main-menu__menu-list-item main-menu__menu-list-item--cta">
                <Link
                  text="Join Us"
                  to="/become-a-member/"
                  modifier="--magenta-button"
                />
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div className="main-menu main-menu--is-desktop">
        <nav aria-label="Main Navigation Menu">
          <ul className="main-menu__menu">
            {/* Menu Item 1 */}
            <li className="main-menu__menu-list-item">
              <Link text="About Us" to="/about-us/" modifier="--menu-item" />
            </li>

            {/* Menu Item 2 */}
            <li className="main-menu__menu-list-item">
              <Link
                text="Our Members"
                to="/our-members/"
                modifier="--menu-item"
              />
            </li>

            {/* Menu Item 3 */}
            <li className="main-menu__menu-list-item">
              <Link
                text="Projects Showcase"
                to="/projects-showcase/"
                modifier="--menu-item"
              />
            </li>

            {/* Menu Item 4 with Submenu */}
            <li
              className={`main-menu__menu-list-item main-menu__menu-list-item--has-submenu ${
                submenuOpen ? "main-menu__submenu--open" : ""
              }`}
            >
              <Button
                modifier="--submenu-button"
                text="Resources Hub"
                onClick={subMenuClicked}
                onMouseEnter={subMenuHoverTrue}
                onMouseOut={subMenuHoverFalse}
                onMouseLeave={subMenuHoverFalse}
                hasPopup="true"
                ariaExpanded={submenuOpen}
                onBlur={() => void 0}
                icon="chevron"
                ariaControls="submenu-dropdown-2"
              />

              <div className="main-menu__submenu">
                <ul
                  className="main-menu__submenu-list"
                  id="submenu-dropdown-2"
                  aria-label="Submenu Dropdown"
                >
                  {/* Submenu Item 1 */}
                  <li className="main-menu__menu-list-item">
                    <Link
                      text="All Resources"
                      to="/resources-hub/"
                      modifier="--menu-item"
                    />
                  </li>

                  {/* Submenu Item 2 */}
                  <li className="main-menu__menu-list-item">
                    <Link
                      text="News"
                      to="/resources/news-posts/"
                      modifier="--menu-item"
                    />
                  </li>

                  {/* Submenu Item 3 */}
                  <li className="main-menu__menu-list-item">
                    <Link
                      text="Events"
                      to="/resources/event-posts/"
                      modifier="--menu-item"
                    />
                  </li>

                  {/* Submenu Item 4 */}
                  <li className="main-menu__menu-list-item">
                    <Link
                      text="Publications"
                      to="/resources/publications/"
                      modifier="--menu-item"
                    />
                  </li>

                  {/* Submenu Item 5 */}
                  <li className="main-menu__menu-list-item">
                    <Link
                      text="Newsletter"
                      to="/resources/newsletter/"
                      modifier="--menu-item"
                    />
                  </li>

                  {/* Submenu Item 6 */}
                  <li className="main-menu__menu-list-item">
                    <Link
                      text="Press Kit"
                      to="/resources/press-kit/"
                      modifier="--menu-item"
                    />
                  </li>
                </ul>
              </div>
            </li>

            {/* Menu Item 5 */}
            <li className="main-menu__menu-list-item">
              <Link
                text="Contact Us"
                to="/contact-us/"
                modifier="--menu-item"
              />
            </li>

            {/* Menu Item 6 */}
            <li className="main-menu__menu-list-item main-menu__menu-list-item--cta">
              <Link
                text="Join Us"
                to="/become-a-member/"
                modifier="--magenta-button"
              />
            </li>
          </ul>
        </nav>
      </div>
    </>
  )
}

export default MainMenu
